import "./Footer.scss";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import AdminCompanyModal from "./AdminCompanyModal";
import React, { ChangeEventHandler, useEffect, useState } from "react";
import AdminKeyboard from "./AdminKeyboard";
import { useLocation } from "react-router-dom";
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import AdminLoginKeyboard from "./AdminLoginKeyboard";
import AdminLoginModal from "./AdminLoginModal";
import { CompanyInfoRequest, CompanyInfoResponse, CompanyInfoResponseData } from "../types/CompanyTypes";
import axiosInstance from "../api/axiosInstance";
import { useHistory } from "react-router-dom";
import AlertModal from "./AlertModal";
import ConfirmModal from "./ConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import { rootReducer } from "../store/store";
import { loginUserId } from "../actions/authActions";
type AuthState = ReturnType<typeof rootReducer>;
const adminKeyboardBasic = {
  adminLoginShow: false,
  admingLoginKeyboardShow: false,
  keyboardShow: false
}

const alertInfoType = {
  alertShow: false,
  title: '',
  content: ''
}

interface keyboardType {
  companyLoginId: string,
  keyboardLayout: string
}


const Footer: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  // const [companyId, setCompanyId] = useState("");
  const [keyboardShow, setKeyboardShow] = useState(false);
  const [confirmShow, setConfirmShow] = useState<boolean>(false);
  const [alertInfo, setAlertInfo] = useState(alertInfoType);
  const [adminModalShow, setAdminModalShow] = useState<boolean>(false)
  const [adminKeyboard, setAminKeyboard] = useState(adminKeyboardBasic)
  const [companyLoginInfo, setCompanyLoginInfo] = useState<keyboardType>({ companyLoginId: '', keyboardLayout: 'default' })
  const [companyId, setRootCompanyId] = useState("");
  const location = useLocation();
  const showPage = ['/main']
  const history = useHistory();
  const dispatch = useDispatch();
  // const onCallback = (id: any) => {
  //   console.log(id);
  //   setCompanyId(id.companyId as any);
  //   setShowModal(false);
  //   setKeyboardShow(true);
  // };

  const onKeyboardCallback = async (props: any) => {
    console.log(props)
    await axiosInstance()
      .post(`/kiosk/adminSameCheck.do`, {
        companyId: companyId,
        userId: props.userId,
        kioskLoginPwd: props.userPassword,
      }).then((res) => {
        if (res.data.resultCode === '0') {
          setAminKeyboard({
            admingLoginKeyboardShow: false,
            adminLoginShow: false,
            keyboardShow: false
          })
          dispatch(loginUserId(props.userId));
          history.push(`/adminPay/${companyLoginInfo.companyLoginId}/${companyId}`);
        } else {
          setAlertInfo({
            alertShow: true,
            title: '비밀번호 오류',
            content: '비밀번호를 다시 확인해주세요.'
          })
        }
      })
  }

  const selCompanyIdByLoginId = async () => {
    await axiosInstance()
      .post<CompanyInfoRequest, CompanyInfoResponse>('/kiosk/selectCompanyByLoginId.do', {
        loginId: companyLoginInfo.companyLoginId
      }).then((res: CompanyInfoResponse) => {
        console.log(res.data)
        if (res.data.status === 200) {
          setRootCompanyId(String(res.data.data.companyId));
          setAminKeyboard({
            adminLoginShow: false,
            admingLoginKeyboardShow: false,
            keyboardShow: true
          })
        } else {
          setAlertInfo({
            alertShow: true,
            title: '비밀번호 오류',
            content: res.data.resultMsg
          })
        }
      })
  }

  const onKeyPress: ChangeEventHandler<HTMLElement> = (event) => {
    console.log(event)
    // 쉬프트 버튼 눌렀을 때
    if (String(event) === '{shift}') {
      setCompanyLoginInfo(prev => ({
        ...prev,
        keyboardLayout: 'shift'
      }))
      // 대문자 키패드에서 쉬프트 눌렀을 때
    } else if (String(event) === '{shiftactivated}') {
      setCompanyLoginInfo(prev => ({
        ...prev,
        keyboardLayout: 'default'
      }))
      // 백스페이스 입력시
    } else if (String(event) === '{bksp}') {
      setCompanyLoginInfo(prev => ({
        ...prev,
        companyLoginId: prev.companyLoginId.slice(0, -1)
      }))
    }
    // 문자나 숫자 입력시에는 TEXT 합치기
    else {
      setCompanyLoginInfo(prev => ({
        ...prev,
        companyLoginId: prev.companyLoginId + event
      }))
    }
  }

  useEffect(() => {
    if (showPage.includes(location.pathname)) setAdminModalShow(true)
    else { setAdminModalShow(false) }
  }, [location.pathname])
  return (
    <>
      <div className="footer-wrap">
        <div className="footer-admin-wrap">
          {adminModalShow &&
            <>
              <div className="admin-wrap" onClick={() => {
                setConfirmShow(true)
              }}>
                <SvgIcon component={PowerSettingsNewIcon} className="exit-icon" />
              </div>

              <div
                className="admin-wrap"
                onClick={() => {
                  setAminKeyboard(prev => ({
                    ...prev,
                    adminLoginShow: !prev.adminLoginShow,
                    admingLoginKeyboardShow: !prev.admingLoginKeyboardShow
                  }))
                }}
              >
                <SvgIcon
                  component={ManageAccountsOutlinedIcon}
                  className="admin-icon"
                ></SvgIcon>
                <span>Admin</span>
              </div>
            </>
          }
        </div>
        {adminKeyboard.adminLoginShow && (
          <AdminLoginKeyboard onClick={selCompanyIdByLoginId} onKeyPress={onKeyPress}
            layoutName={companyLoginInfo.keyboardLayout} />
        )}

        {adminKeyboard.admingLoginKeyboardShow && (
          <AdminLoginModal loginId={companyLoginInfo.companyLoginId} />
        )}

        {adminKeyboard.keyboardShow && (
          <AdminKeyboard
            companyId={companyId}
            target={"admin"}
            show={adminKeyboard.keyboardShow}
            onCallback={onKeyboardCallback}
            onClose={() => {
              setAminKeyboard(prev => ({ ...prev, keyboardShow: false }))
            }}
          ></AdminKeyboard>
        )}
        {alertInfo.alertShow && (
          <AlertModal
            onClose={() => {
              setAlertInfo(prev => ({
                ...prev,
                alertShow: false
              }))
            }}
            title={alertInfo.title}
            content={alertInfo.content}
          ></AlertModal>
        )}
        {/* {showModal && (
          <AdminCompanyModal
            onCallback={onCallback}
            show={showModal}
          ></AdminCompanyModal>
        )}
        {keyboardShow && (
          <AdminKeyboard
            companyId={companyId}
            show={keyboardShow}
            target={'admin'}
            onClose={() => {
              setKeyboardShow(false);
            }}
          ></AdminKeyboard>
        )} */}

        <ConfirmModal
          isOpen={confirmShow}
          title={"전원을 종료하시겠습니까?"}
          message={
            "정말로 전원을 끄시겠습니까? </br> 관리자 이외에는 종료하지 말아주세요."
          }
          onCancel={() => {
            setConfirmShow(false);
          }}
          onConfirm={() => {
            window.chrome.webview.postMessage({ exit: "exit" })
          }}
        ></ConfirmModal>
      </div>
    </>
  );
};

export default Footer;
